import MultiButton from './MultiButton';

export default MultiButton;
